module.exports = __webpack_public_path__ + "static/media/Seal_Symantec_Trans.097f7d5c.svg";